import LeadsContext from "./index";
import { DataStore, SortDirection } from "@aws-amplify/datastore";
import { Leads } from "../../models";
import { useState } from "react";
import {
  getByCodePostal,
  getBranchByZC,
  getCollaborators,
} from "../../helpers/queries";
import moment from "moment";

export default function LeadsProvider({ children }) {
  const [models, setModels] = useState([]);
  const [modelsOrig, setModelsOrig] = useState([]);
  const [optZip, setOptZip] = useState([]);
  const [optBranch, setOptBranch] = useState([]);
  const [obtAdress, setObtAdress] = useState([]);
  const [optCollaborators, setOptColaborators] = useState([]);
  const [collsActive, setCollsActive] = useState([]);
  const [collaboratorID, setCollaboratorID] = useState({});
  const [branchName, setBranchName] = useState({});
  const [toggle, setToggle] = useState(0);

  const Subs = () => {
    const subscription = DataStore.observe(Leads).subscribe((msg) => {
      console.log(msg.model, msg.opType, msg.element);
      setToggle(msg.opType);
    });
  };

  const Leadslist = async (status, order, by = "asignation") => {
    const subscription = DataStore.observeQuery(Leads, (c) =>
      c.status.eq(status)
    ).subscribe((snapshot) => {
      const { items, isSynced } = snapshot;
      console.log(
        `[Snapshot] item count: ${items.length}, isSynced: ${isSynced}`
      );
      //const itemsOrder = items.sort((a,b) => moment(a.dateRegistry, "DD-MM-YYYY HH:mm").unix() - moment(b.dateRegistry, "DD-MM-YYYY HH:mm").unix());
      if (by === "asignation") {
        if (order === "1") {
          items.sort(
            (a, b) =>
              moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
              moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix()
          );
        } else {
          items.sort(
            (a, b) =>
              moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
              moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix()
          );
        }
      } else {
        if (order === "1") {
          items.sort(
            (a, b) =>
              moment(a.dateRegistry, "DD-MM-YYYY HH:mm").unix() -
              moment(b.dateRegistry, "DD-MM-YYYY HH:mm").unix()
          );
        } else {
          items.sort(
            (a, b) =>
              moment(b.dateRegistry, "DD-MM-YYYY HH:mm").unix() -
              moment(a.dateRegistry, "DD-MM-YYYY HH:mm").unix()
          );
        }
      }

      setModels(items);
      setModelsOrig(items);
    });
    return () => {
      subscription.unsubscribe();
    };
  };

  const LeadsManagers = async (status, order, idBranch) => {
    const subscription = DataStore.observeQuery(Leads, (c) =>
      c.and((c) => [c.status.eq(status), c.idBranch.eq(idBranch)])
    ).subscribe((snapshot) => {
      const { items, isSynced } = snapshot;
      console.log(
        `[Snapshot] item count: ${items.length}, isSynced: ${isSynced}`
      );
      // console.log(items);
      if (order === "1") {
        items.sort(
          (a, b) =>
            moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
            moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix()
        );
      } else {
        items.sort(
          (a, b) =>
            moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
            moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix()
        );
      }

      setModels(items);
      setModelsOrig(items);
    });
    return () => {
      subscription.unsubscribe();
    };
    //setModels(data);
    //setModelsOrig(data);
  };

  const LeadsAsigners = async (status, status2, order, idBranch) => {
    const subscription = DataStore.observeQuery(Leads, (c) =>
    c.or(
      (c) => [c.status.eq(status), c.status.eq(status2)])
    ).subscribe((snapshot) => {
      const { items, isSynced } = snapshot;
      console.log(
        `[Snapshot] item count: ${items.length}, isSynced: ${isSynced}`
      );
      const itemsB = items.filter(item => item.idBranch === idBranch);
       console.log(itemsB);
      if (order === "1") {
        itemsB.sort(
          (a, b) =>
            moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
            moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix()
        );
      } else {
        itemsB.sort(
          (a, b) =>
            moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
            moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix()
        );
      }

      setModels(itemsB);
      setModelsOrig(itemsB);
    });
    return () => {
      subscription.unsubscribe();
    };
    //setModels(data);
    //setModelsOrig(data);
  };
  const LeadsAsign = async (status, status2, order, by = "asignation") => {
    const subscription = DataStore.observeQuery(Leads, (c) =>
      c.or((c) => [c.status.eq(status), c.status.eq(status2)])
    ).subscribe((snapshot) => {
      const { items, isSynced } = snapshot;
      console.log(
        `[Snapshot] item count: ${items.length}, isSynced: ${isSynced}`
      );
      // console.log(items);
      if (by === "asignation") {
        if (order === "1") {
          items.sort(
            (a, b) =>
              moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
              moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix()
          );
        } else {
          items.sort(
            (a, b) =>
              moment(b.dateAsignation, "DD-MM-YYYY HH:mm").unix() -
              moment(a.dateAsignation, "DD-MM-YYYY HH:mm").unix()
          );
        }
      } else {
        if (order === "1") {
          items.sort(
            (a, b) =>
              moment(a.dateRegistry, "DD-MM-YYYY HH:mm").unix() -
              moment(b.dateRegistry, "DD-MM-YYYY HH:mm").unix()
          );
        } else {
          items.sort(
            (a, b) =>
              moment(b.dateRegistry, "DD-MM-YYYY HH:mm").unix() -
              moment(a.dateRegistry, "DD-MM-YYYY HH:mm").unix()
          );
        }
      }

      setModels(items);
      setModelsOrig(items);
    });
    return () => {
      subscription.unsubscribe();
    };
    //setModels(data);
    //setModelsOrig(data);
    //console.log(data);
  };

  const obtainBranch = async (codePostal) => {
    getBranchByZC(String(codePostal).trim()).then(function (branchlist) {
      if (branchlist === "error") {
        setOptBranch([]);
      } else {
        setOptBranch(branchlist);
      }
    });
  };

  const obtainSuburb = async (codePostal) => {
    getByCodePostal(String(codePostal).trim()).then(function (responseCP) {
      if (responseCP === "error") {
        setOptZip([]);
      } else {
        setOptZip(responseCP);
      }
    });
  };

  const obtainCollaborators = async (idBranch) => {
    getCollaborators(idBranch).then(function (responseColl) {
      if (responseColl === "error") {
        setOptColaborators([]);
        console.log("error", responseColl);
      } else {
        setOptColaborators(responseColl);
        FilterCollsActives();
      }
    });
  };

  const FilterChannel = (canal) => {
    let resultadosFiltro = modelsOrig.filter((leadCanal) => {
      if (leadCanal.channel?.toString().includes(canal)) {
        return leadCanal;
      }
    });
    setModels(resultadosFiltro);
  };

  const FilterConekta = (asesor) => {
    let resultadosFiltro = modelsOrig.filter((leadConekta) => {
      if (leadConekta.conekta?.toString().includes(asesor)) {
        return leadConekta;
      }
    });
    setModels(resultadosFiltro);
  };

  const FilterAdvicer = (asesor) => {
    let resultadosFiltro = modelsOrig.filter((leadAdvicer) => {
      if (leadAdvicer.advicer?.toString().includes(asesor)) {
        return leadAdvicer;
      }
    });
    setModels(resultadosFiltro);
  };
  
  const FilterModelsbyBranch = (idBranch) => {
    let resultadosFiltro = modelsOrig.filter((leadbyBranch) => {
      if (leadbyBranch.idBranch == idBranch) {
        return leadbyBranch;
      }
    });
    setModels(resultadosFiltro);
  };

  const FilterCollsActives = () => {
    let resultadosFiltro = optCollaborators.filter((CollsActives) => {
      if (
        CollsActives.statusEmployee?.toString() === "Activo" &&
        CollsActives.function?.toString() === "Asesor"
      ) {
        return CollsActives;
      }
    });
    setCollsActive(resultadosFiltro);
  };

  const FilterCollsID = (id) => {
    let resultadosFiltro = collsActive.find((CollabotarorID) => {
      if (CollabotarorID.id == id) {
        return CollabotarorID;
      }
    });
    setCollaboratorID(resultadosFiltro);
  };

  const FilterBranchName = (id) => {
    let resultadosFiltro = optBranch.find((BranchName) => {
      if (BranchName.id == id) {
        return BranchName;
      }
    });
    setBranchName(resultadosFiltro);
  };

  const Search = (busqueda) => {
    let resultadosBusqueda = modelsOrig.filter((leadSearch) => {
      if (
        leadSearch.name
          ?.toString()
          .toLowerCase()
          .includes(busqueda.toLowerCase()) ||
        leadSearch.firstLastName
          ?.toString()
          .toLowerCase()
          .includes(busqueda.toLowerCase()) ||
        leadSearch.secondLastName
          ?.toString()
          .toLowerCase()
          .includes(busqueda.toLowerCase()) ||
        leadSearch.conekta
          ?.toString()
          .toLowerCase()
          .includes(busqueda.toLowerCase()) ||
        leadSearch.channel
          ?.toString()
          .toLowerCase()
          .includes(busqueda.toLowerCase()) ||
        leadSearch.advicer
          ?.toString()
          .toLowerCase()
          .includes(busqueda.toLowerCase()) ||
          leadSearch.branch
            ?.toString()
            .toLowerCase()
            .includes(busqueda.toLowerCase())
      ) {
        return leadSearch;
      }
    });
    setModels(resultadosBusqueda);
  };

  const getAdress = (busqueda) => {
    let resultadosBusqueda = optZip.filter((asentamientoSearch) => {
      if (asentamientoSearch.asentamiento?.toString().includes(busqueda)) {
        return asentamientoSearch;
      }
    });
    setObtAdress(resultadosBusqueda[0]);
  };

  return (
    <LeadsContext.Provider
      value={{
        Leadslist,
        models,
        modelsOrig,
        optZip,
        setOptZip,
        optBranch,
        setOptBranch,
        Search,
        FilterChannel,
        FilterConekta,
        LeadsManagers,
        FilterAdvicer,
        LeadsAsign,
        obtainSuburb,
        obtainBranch,
        getAdress,
        obtAdress,
        setObtAdress,
        optCollaborators,
        obtainCollaborators,
        FilterCollsActives,
        collsActive,
        FilterCollsID,
        collaboratorID,
        LeadsAsigners,
        FilterBranchName,
        branchName,
        Subs,
        toggle,
        FilterModelsbyBranch
      }}
    >
      {children}
    </LeadsContext.Provider>
  );
}
